export default "__VITE_ASSET__BuDVRWWa__"